export const events = {
  FILE_UPLOADED: 'event: file uploaded',
  DOMAIN_SELECTED: 'event: domain selected'
}
